import { render } from "./PrimaryContent.vue?vue&type=template&id=39a610c8&scoped=true"
import script from "./PrimaryContent.vue?vue&type=script&lang=js"
export * from "./PrimaryContent.vue?vue&type=script&lang=js"

import "./PrimaryContent.vue?vue&type=style&index=0&id=39a610c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a610c8"]])

export default __exports__